import { render, staticRenderFns } from "./UploadFileAsUserModal.vue?vue&type=template&id=4f1b7f6a&scoped=true"
import script from "./UploadFileAsUserModal.vue?vue&type=script&lang=js"
export * from "./UploadFileAsUserModal.vue?vue&type=script&lang=js"
import style0 from "./UploadFileAsUserModal.vue?vue&type=style&index=0&id=4f1b7f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b7f6a",
  null
  
)

export default component.exports